import React from 'react';
import { Redirect, useParams } from 'react-router';
import { getDropFromTokenId } from 'utils/token';

interface TokenPageProps {}

const TokenPage: React.FC<TokenPageProps> = () => {
  const { id } = useParams<any>();
  const drop = getDropFromTokenId(id);

  return <Redirect to={`/${drop}/${id}`} />;
};

export default TokenPage;
